module.exports = new __parcel__URL__("placeholder-square.a495ae2d.svg").toString();